export default function ventilationAutomatique(piece) {
  if (piece === null) return;

  piece.mouvementsClients.sort((a, b) => {
    const dateA = new Date(a.dateMouvement);
    const dateB = new Date(b.dateMouvement);
    return dateA - dateB;
  });
  let resteAVentiller = piece.inputAffecte;
  if (piece.escompteApplicable === true) {
    resteAVentiller += piece.montantEscompte;
  }

  piece.mouvementsClients.forEach(mc => {
    const montantVentileMouvementClient = Math.min(mc.restantAAffecterInitial, resteAVentiller);
    mc.inputAffecte = montantVentileMouvementClient;
    resteAVentiller -= mc.inputAffecte;
    mc.solde = mc.restantAAffecterInitial - mc.inputAffecte;
  });
}
